/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "journal";
export const APP_DOMAIN = "app.journal.com";

/**
 * SOFT_DELETE_STANDARD — trash retention window (days). The server purge job
 * (env `TRASH_PURGE_DAYS`, default 30; 0 = off) permanently deletes soft-deleted
 * entries whose `deleted_at` exceeds this threshold (cascading to
 * versions/tags/photos through FKs). The client uses this ONLY for the
 * informational "it will be deleted in Y days" countdown in the trash; the
 * server env is the source of truth for purging.
 */
export const TRASH_PURGE_DAYS = 30;
